import type React from 'react';
import userPersonas from '@common/constants/userPersonas';
import Modal from '@common/components/ConstellationV10Modal';
import { Box, Button, ButtonGroup, FieldSet, Legend, Paragraph, Radio, TextButton } from '@zillow/constellation-10';

type Props = {
  onSubmit: () => void;
  selectedOption: string;
  setSelectedOption: (selectedOption: string) => void;
  onClose: () => void;
  onBack: () => void;
  emergencyMode: boolean;
};

const BusinessTypeSelectorPage: React.FC<React.PropsWithChildren<Props>> = (props: Props): JSX.Element => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      onRequestClose={props.emergencyMode ? undefined : props.onClose}
      header="Payment setup"
      body={
        <FieldSet
          css={{ display: 'grid', gap: 'default' }}
          legend={<Legend css={{ textStyle: 'body-lg-bold' }}>How is the business set up?</Legend>}
        >
          <Paragraph>Choose the specific type of business entity.</Paragraph>
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: 'default',
            }}
          >
            <Radio
              name="business-type"
              css={{ margin: '4px' }}
              onChange={() => props.setSelectedOption('single_member_llc')}
              checked={props.selectedOption === 'single_member_llc'}
              value="single_member_llc"
            />
            <Box>
              <Paragraph textStyle="body-bold">Single-member LLC</Paragraph>
              <Paragraph>
                You registered your business with the state, you are the single member, and it’s a separate entity for
                tax purposes.
              </Paragraph>
            </Box>
          </Box>
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              gap: 'default',
            }}
          >
            <Radio
              name="business-type"
              css={{ margin: '4px' }}
              onChange={() => props.setSelectedOption('multi_member_llc')}
              checked={props.selectedOption === 'multi_member_llc'}
              value="multi_member_llc"
            />
            <Box>
              <Paragraph textStyle="body-bold">Multi-member LLC or corporation</Paragraph>
              <Paragraph>
                Your business is registered with the state as an LLC or corporation with multiple members.
              </Paragraph>
            </Box>
          </Box>
        </FieldSet>
      }
      footer={
        <ButtonGroup aria-label="Business type selection actions">
          <TextButton onClick={props.onBack}>Back</TextButton>
          <Button disabled={!props.selectedOption} onClick={props.onSubmit} emphasis="filled">
            Continue
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default BusinessTypeSelectorPage;
